module.exports = __webpack_public_path__ + "static/img/hbq0417.81c2310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hbq0417.jpg
// module id = UNlX
// module chunks = 0